module.exports = __webpack_public_path__ + "media/images/avatar-fallback-ab98a10d63a606285d4faa30d5aee317.svg";